import { LocalizationService } from '@newo/localization';
import { useMemo, useSyncExternalStore } from 'react';

export function useLocalization() {
	const language = useSyncExternalStore(
		(callback) => LocalizationService.subscribe(callback),
		() => LocalizationService.getLanguage()
	);

	return useMemo(() => {
		return {
			language,
			translate: LocalizationService.translate.bind(LocalizationService),
			rich: LocalizationService.rich.bind(LocalizationService)
		};
	}, [language]);
}
